import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import ZipcodeSearch from '../../search/ZipcodeSearch';

export default function FormInputZipcodeSearch(props) {
  return <FormInputSearch {...props} searchComponent={ZipcodeSearch} />;
}
